import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

class AdapterRegister extends React.Component {
	onSubmitRegister = (e) => {
		e.preventDefault();
		var value={
			adapter: document.getElementById('adapter_name').value,
			className: document.getElementById('adapter_className').value,
			description: document.getElementById('adapter_description').value,
		}
		
		var adapterFile = document.getElementById('adapter_file').files

		if(!this.errorCheck(value, adapterFile)){
			this.props.fetchAdapterRegisterRequest(value, adapterFile[0], e)
		}
	}

	errorCheck = (value, adapterFile) => {
		var errorLabel={}
		
		if(isEmpty(value.adapter)){
			errorLabel={
				...errorLabel,
				name:"aa.button.err.required"
			}
		}
		if(isEmpty(value.className)){
			errorLabel={
				...errorLabel,
				className:"aa.button.err.required"
			}
		}
		if(isEmpty(value.description)){
			errorLabel={
				...errorLabel,
				description:"aa.button.err.required"
			}
		}
		if(isEmpty(adapterFile)){
			errorLabel={
				...errorLabel,
				adapterFile:"aa.button.err.required"
			}
		}
		
		this.props.setErrorLabel(errorLabel)

		if(Object.keys(errorLabel).length > 0){
			return true
		}else{
			return false
		}
	}

	onClickCancel = (e) => {
		this.props.setAdapterRegisterModal()
	}

	onChangeFileInput = (e) => {
		var fileName = e.target.value.split('\\');
		document.getElementById('label_file').innerText = fileName[fileName.length-1]
	}

	render(){
		const {t} = this.props;

		return (
			<div className="modal_overlay" style={{ display: this.props.adapterRegister.modalVisible ? 'block' : 'none' }}>
				<div className="modal_dialog" style={{display: this.props.adapterRegister.modalVisible ? 'block' : 'none'}}>
					<form className="form" onSubmit={this.onSubmitRegister} encType="multipart/form-data">
						<div className="dialog">
							<div className="dialog_tl">{t('aa.text.label.title')}</div>
							<div className="dialog_content">
								<div className="section">
									<div className="item_label">{t('aa.text.label.adapter.name')}</div>
									<input type="text" className="item_input" id="adapter_name" defalutvalue="" placeholder=""/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterRegister.errorLabel.adapter)}</div>
									<div className="item_label">{t('aa.text.label.adapter.class')}</div>
									<input type="text" className="item_input" id="adapter_className" defalutvalue="" placeholder=""/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterRegister.errorLabel.className)}</div>
									<div className="item_label">{t('aa.text.lable.adapter.description')}</div>
									<input type="text" className="item_input" id="adapter_description" defalutvalue="" placeholder=""/>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterRegister.errorLabel.description)}</div>
									<div className="item_label">{t('aa.text.lable.adapter.file')}</div>
									<label htmlFor="adapter_file">
										<div className="file_input" id="label_file">{t('aa.text.lable.adapter.upload.file')}</div>
										<input type="file" id="adapter_file" onChange={this.onChangeFileInput} style={{display:"none"}}/>
									</label>
									<div className="error" style={{display:'block'}}>{t(this.props.adapterRegister.errorLabel.adapterFile)}</div>
									<div className="btn_wrap">
										<button className="btn_text_b btn_text_w" type="reset" onClick={this.onClickCancel}>{t('aa.button.label.cancel')}</button>
										<button className="btn_text_b">{t('aa.button.label.register')}</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
	)}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		adapterRegister: reducers.adapter.adapterRegister,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setErrorLabel: (value) => {dispatch({type: types.SET_ADAPTER_REGISTER_ERRORLABEL,errorLabel:value})},
		setAdapterRegisterModal: () => {dispatch({type: types.SET_ADAPTER_REGISTER_MODAL})},
		fetchAdapterRegisterRequest: (value, adapterFile, e) => {dispatch({type: types.FETCH_SET_ADAPTER_REGISTER_REQUEST, value:value, adapterFile:adapterFile, target:e.target})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AdapterRegister))